/**
 * 菜单模块的接口
 * */
import base from './base' // 接口域名列表
import qs from 'qs' // 序列化post请求的
import axios from '@/utils/http' // 导入创建的axios实例

let www = base.proxy

// 开始定义接口
const menu = {
  MenuMainTypeApi () {
    return axios.post(`${www}/wtapi/external/api/userRole/list/apiType`)
  },
  MenuMainApi () {
    return axios.post(`${www}//wtapi/external/api/userRole/list/api`)
  },
  SafeCenterApi () {
    return axios.post(`${www}/wtapi/external/api/userRole/list/navigation`)
  },
  MenuDetailApi (params) {
    if (qs.stringify(params.query) !== '') {
      return axios.post(`${www}/wtapi/external/api/info/apiDetail/${params.id}`, qs.stringify(params.query))
    } else {
      return axios.post(`${www}/wtapi/external/api/info/apiDetail/${params.id}`)
    }
  },
  InfoApi (type, id) {
    return axios.post(`${www}/wtapi/external/api/info/common/${type}`, qs.stringify({ id: id }), {
      header: {
        'Content-Type': 'application/json'
      }
    })
  },
  loadChildrenApi (id) {
    return axios.post(`${www}/wtapi/external/api/dataSource/loadChildren/${id}`, qs.stringify({ id: id }))
  }
}

export default menu



// WEBPACK FOOTER //
// ./src/api/menu.js